export const ACTION_UPDATE_CLIENT = 'ACTION_UPDATE_CLIENT';

export const updateClient = client => ({
    payload: {
        client
    },
    type: ACTION_UPDATE_CLIENT
});
